<template>
    <div class="success-block">
        <img src="/icon/success_modal.svg" class="icon-success" alt="success" />
        <div>
            <p class="success-title">Заявка отправлена!</p>
        </div>
        <span class="success-description">
            Менеджер скоро перезвонит вам для уточнения всех деталей по заявке.
        </span>
    </div>
</template>

<script setup lang="ts">
import { useContentPages } from '~/stores/homeStores';

const contentPagesStore = useContentPages();
const consultFormData = computed(() => contentPagesStore.getContactFormData);
</script>

<style lang="scss" scoped>
.success-body {
    max-width: 480px;
}
.icon-success {
    width: 5rem;
    height: 5rem;
}
.success-title {
    color: #2B2B2B;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    leading-trim: NONE;
    line-height: 46px;
    letter-spacing: 0%;
    text-align: center;

}
.success-description {
    color: #2B2B2B;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    text-align: center;

}
.success-block {
    display: flex;
    flex-direction: column;
    gap: 28px;
    justify-content: center;
    align-items: center;
    max-width: 22.5rem;
    width: 100%;
}

@media (max-width: 480px) {
    .success-block {
        gap: 20px;
    }
}
</style>
